var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2226_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7941 46.3929C27.318 49.869 21.6821 49.869 18.2059 46.3929L2.60709 30.7941C-0.869029 27.318 -0.869029 21.6821 2.60709 18.2059L18.2059 2.60709C21.6821 -0.869029 27.318 -0.869029 30.7941 2.60709L46.3929 18.2059C49.869 21.6821 49.869 27.318 46.3929 30.7941L30.7941 46.3929Z",
    fill: "url(#paint0_linear_2226_229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.087 45.6858C27.0014 48.7714 21.9986 48.7714 18.913 45.6858L3.31419 30.087C0.228602 27.0014 0.228602 21.9986 3.31419 18.913L18.913 3.31419C21.9986 0.228602 27.0014 0.228602 30.087 3.31419L45.6858 18.913C48.7714 21.9986 48.7714 27.0014 45.6858 30.087L30.087 45.6858Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_angular_2226_229_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.003 -0.003 0 25 25.2002)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1333.33,
    y: -1333.33,
    width: 2666.67,
    height: 2666.67
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(224, 224, 224, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 22.3846C24.8243 22.1387 25.1757 22.1387 25.3024 22.3846L26.1074 23.9463C26.1398 24.0092 26.191 24.0604 26.2539 24.0928L27.8156 24.8978C28.0615 25.0245 28.0615 25.3759 27.8156 25.5026L26.2539 26.3076C26.191 26.34 26.1398 26.3912 26.1074 26.4541L25.3024 28.0158C25.1757 28.2616 24.8243 28.2616 24.6976 28.0158L23.8926 26.4541C23.8602 26.3912 23.809 26.34 23.7461 26.3076L22.1844 25.5026C21.9385 25.3759 21.9385 25.0245 22.1844 24.8978L23.7461 24.0928C23.809 24.0604 23.8602 24.0092 23.8926 23.9463L24.6976 22.3846Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87999999523162842,\"g\":0.87999999523162842,\"b\":0.87999999523162842,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87999999523162842,\"g\":0.87999999523162842,\"b\":0.87999999523162842,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":3.6739405577555036e-16,\"m01\":-6.0,\"m02\":28.0,\"m10\":6.0,\"m11\":3.6739405577555036e-16,\"m12\":22.20019531250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_angular_2226_229_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.003 0 0 -0.003 25 25.2002)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1333.33,
    y: -1333.33,
    width: 2666.67,
    height: 2666.67
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(224, 224, 224, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 0.5
    }
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 22.3846C24.8243 22.1387 25.1757 22.1387 25.3024 22.3846L26.1074 23.9463C26.1398 24.0092 26.191 24.0604 26.2539 24.0928L27.8156 24.8978C28.0615 25.0245 28.0615 25.3759 27.8156 25.5026L26.2539 26.3076C26.191 26.34 26.1398 26.3912 26.1074 26.4541L25.3024 28.0158C25.1757 28.2616 24.8243 28.2616 24.6976 28.0158L23.8926 26.4541C23.8602 26.3912 23.809 26.34 23.7461 26.3076L22.1844 25.5026C21.9385 25.3759 21.9385 25.0245 22.1844 24.8978L23.7461 24.0928C23.809 24.0604 23.8602 24.0092 23.8926 23.9463L24.6976 22.3846Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87843137979507446,\"g\":0.87843137979507446,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87843137979507446,\"g\":0.87843137979507446,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":-6.0,\"m01\":-6.3918976448557041e-13,\"m02\":28.0,\"m10\":-2.8473786371253917e-13,\"m11\":-6.0,\"m12\":28.20019531250},\"opacity\":0.50,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7469 22.1555C25.434 21.5484 24.566 21.5484 24.2531 22.1555L23.4716 23.6718L21.9553 24.4533C21.3482 24.7662 21.3482 25.6342 21.9553 25.9471L23.4716 26.7286L24.2531 28.2449C24.566 28.852 25.434 28.852 25.7469 28.2449L26.5284 26.7286L28.0447 25.9471C28.6518 25.6342 28.6518 24.7662 28.0447 24.4533L26.5284 23.6718L25.7469 22.1555Z",
    stroke: "black",
    strokeOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20923 33.396L33.3962 5.20898L43.7907 15.6035L15.6037 43.7904L5.20923 33.396Z",
    fill: "url(#paint3_linear_2226_229)",
    fillOpacity: 0.32
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2226_229",
    x: 0,
    y: 0,
    width: 49,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117138 0 0 0 0 0.176258 0 0 0 0 0.202862 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2226_229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2226_229",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_angular_2226_229_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 22.3846C24.8243 22.1387 25.1757 22.1387 25.3024 22.3846L26.1074 23.9463C26.1398 24.0092 26.191 24.0604 26.2539 24.0928L27.8156 24.8978C28.0615 25.0245 28.0615 25.3759 27.8156 25.5026L26.2539 26.3076C26.191 26.34 26.1398 26.3912 26.1074 26.4541L25.3024 28.0158C25.1757 28.2616 24.8243 28.2616 24.6976 28.0158L23.8926 26.4541C23.8602 26.3912 23.809 26.34 23.7461 26.3076L22.1844 25.5026C21.9385 25.3759 21.9385 25.0245 22.1844 24.8978L23.7461 24.0928C23.809 24.0604 23.8602 24.0092 23.8926 23.9463L24.6976 22.3846Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_angular_2226_229_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 22.3846C24.8243 22.1387 25.1757 22.1387 25.3024 22.3846L26.1074 23.9463C26.1398 24.0092 26.191 24.0604 26.2539 24.0928L27.8156 24.8978C28.0615 25.0245 28.0615 25.3759 27.8156 25.5026L26.2539 26.3076C26.191 26.34 26.1398 26.3912 26.1074 26.4541L25.3024 28.0158C25.1757 28.2616 24.8243 28.2616 24.6976 28.0158L23.8926 26.4541C23.8602 26.3912 23.809 26.34 23.7461 26.3076L22.1844 25.5026C21.9385 25.3759 21.9385 25.0245 22.1844 24.8978L23.7461 24.0928C23.809 24.0604 23.8602 24.0092 23.8926 23.9463L24.6976 22.3846Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2226_229",
    x1: 24.4999,
    y1: 52.6871,
    x2: 24.4999,
    y2: -3.6869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AA8B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE5E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2226_229",
    x1: 38.1231,
    y1: 1.57127,
    x2: 0.404312,
    y2: 45.4891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125287,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375692,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929467,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop2);
export default __webpack_public_path__ + "static/media/top2.ceed6b51d3e96248896323b4510594d3.svg";
export { ForwardRef as ReactComponent };